class Validator {
	// This class will take in an array of options, and simply report back true or false with an error message if false

	required = (input) => {
		var ret = {
			message: '',
			status: false
		}


		if(typeof input == 'number') {
			return true
		}

		// Check if string
		if(typeof input == 'string') {
			if(input.length > 0) {
				return true
			}
		}

		if(typeof input == 'object') {
			if(input === false || input === null) {
				return ret
			}
			else {
				return true
			}
			
		}

		// Doesn't match any above, it's false
		return ret
	}

	requiredTypeahead = (input, options) => {

		// Validate that the input is in the list of typeahead options.

		var status = {
			message: 'Please choose an option from the list.',
			status: false
		}

		options.map((r) => {
			if(input == r.label) {
				status = true
			}
		})

		return status
	}

	requiredTypeaheadByID = (input, options) => {

		// Validate that the input is in the list of typeahead options.

		var status = {
			message: 'Please choose an option from the list.',
			status: false
		}

		options.map((r) => {
			if(input == r.id) {
				status = true
			}
		})

		return status
	}

	requiredCheckbox = set => {
		return (set.size > 0 ? true : false)
	}

	phone = (input) => {
		if(input.length == 10) {
			return true
		}
		else {
			return false
		}
	}

	email = (input) => {
		if(input.length == 0) { return true }
		var approve = require('approvejs')
		var check = approve.value(input, {email:true})

		if(check.approved) {
			return true
		}
		else {
			return false
		}
	}

}

export default Validator
